module.exports = __webpack_public_path__ + "static/media/backdrop.b56c7a8c.png";